import ProcessingActionButtons from '../components/technician/ProcessingActionButtons';
import ProcessingStepsList from '../components/ProcessingStepsList';
import { Box, Button, Typography } from '@mui/material';
import ScanResourceId from '../components/technician/ScanResourceId';
import ProcessingHeader from './processingWorkflow/ProcessingHeader';
import ProcessingInfoCard from './processingWorkflow/ProcessingInfoCard';
import ProcessingWorkflowDialogs from './processingWorkflow/ProcessingWorkflowDialogs';
import useProcessingWorkflowController from '../hooks/useProcessingWorkflowController';
import type { ProcessingWorkflowProps } from './processingWorkflow/types';

export const ProcessingWorkflow = (props: ProcessingWorkflowProps = {}) => {
    const controller = useProcessingWorkflowController(props);
    const {
        spLotIds,
        isBulkView,
        spLotInfo,
        processingSteps,
        expandedStep,
        setExpandedStep,
        commentDialogOpen,
        setCommentDialogOpen,
        materialDialogOpen,
        setMaterialDialogOpen,
        spLotsDialogOpen,
        setSpLotsDialogOpen,
        confirmDialogOpen,
        setConfirmDialogOpen,
        skipDialogOpen,
        setSkipDialogOpen,
        skipComment,
        setSkipComment,
        commentText,
        setCommentText,
        originalCommentText,
        currentStepForComment,
        expandedInfo,
        setExpandedInfo,
        loading,
        showScanResourceId,
        scanMode,
        
        isActionInProgress,
        classes,
        getCropNameByCode,
        stepRefs,
        handleBackNavigation,
        handleAddComment,
        handleSaveComment,
        handleBeginProcessing,
        handleResourceScanned,
        handleSkipEquipmentScan,
        handleScanBack,
        handleMarkAsDone,
        handleConfirmMarkAsDone,
        handleSkipStep,
        handleConfirmSkipStep,
        isBeginProcessingEnabled,
        isMarkAsDoneEnabled,
        shouldShowSkipButton,
        shouldShowButton,
        hasInProgressStep,
    } = controller as any;

    if (loading || !spLotInfo) return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}><Typography className={classes.labelNoto16Bold400_hh}>Loading...</Typography></Box>;

    if (showScanResourceId) {
        const currentStep = controller.getCurrentStepFromApi();
        const stepForScan = (currentStep && controller.isCurrentStatus('Not Started')) ? currentStep : undefined;
        return (
            <ScanResourceId
                onResourceScanned={handleResourceScanned}
                onBack={handleScanBack}
                onSkip={scanMode === 'equipment' ? handleSkipEquipmentScan : undefined}
                scanMode={scanMode}
                isEquipmentMandatory={controller.isCurrentStepEquipmentMandatory(stepForScan)}
                currentStepName={stepForScan?.name}
                currentStepEquipments={stepForScan?.equipments ?? []}
                mappedTreatments={stepForScan?.mappedTreatments ?? []}
            />
        );
    }

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5', pb: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <ProcessingHeader isBulkView={isBulkView} spLotIds={spLotIds} processingSteps={processingSteps} handleBackNavigation={handleBackNavigation} setSpLotsDialogOpen={setSpLotsDialogOpen} classes={classes} />
            <Box sx={{ pt: '8px', px: 2, pb: '5px', width: '100%', margin: '0 auto' }}>
                <ProcessingInfoCard spLotInfo={spLotInfo} expandedInfo={expandedInfo} setExpandedInfo={setExpandedInfo} setMaterialDialogOpen={setMaterialDialogOpen} classes={classes} getCropNameByCode={getCropNameByCode} />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: '13px', mb: '5px', px: 0 }}>
                    <Typography variant="subtitle1" className={classes.labelNoto16Bold500_hh} sx={{ ml: '10px' }}>Processing steps</Typography>
                    <Button variant="outlined" size="small" className={classes.labelNoto12Bold400_hh} disableRipple sx={{ textTransform: 'none', color: '#000000', borderColor: '#9e9b9b', backgroundColor: '#dfdcdc' }}>Report No Seed</Button>
                </Box>

                <Box sx={{ height: '1px', backgroundColor: '#e0e0e0', mb: '16px' }} />

                <ProcessingStepsList processingSteps={processingSteps} isBulkView={isBulkView} expandedStep={expandedStep} currentStepId={spLotInfo?.currentStepId} currentStepStatus={spLotInfo?.currentStepStatus} stepRefs={stepRefs} handleStepClick={(id:number)=>setExpandedStep(id)} handleAddComment={handleAddComment} classes={classes} />

                <ProcessingActionButtons hasInProgressStep={hasInProgressStep} isBeginProcessingEnabled={isBeginProcessingEnabled} isMarkAsDoneEnabled={isMarkAsDoneEnabled} shouldShowButton={shouldShowButton} handleBeginProcessing={handleBeginProcessing} handleMarkAsDone={handleMarkAsDone} shouldShowSkipButton={shouldShowSkipButton} handleSkipStep={handleSkipStep} isActionInProgress={isActionInProgress} classes={classes} />
            </Box>

            <ProcessingWorkflowDialogs commentDialogOpen={commentDialogOpen} setCommentDialogOpen={setCommentDialogOpen} handleSaveComment={handleSaveComment} commentText={commentText} setCommentText={setCommentText} currentStepForComment={currentStepForComment} originalCommentText={originalCommentText} processingSteps={processingSteps} materialDialogOpen={materialDialogOpen} setMaterialDialogOpen={setMaterialDialogOpen} spLotsDialogOpen={spLotsDialogOpen} setSpLotsDialogOpen={setSpLotsDialogOpen} confirmDialogOpen={confirmDialogOpen} setConfirmDialogOpen={setConfirmDialogOpen} skipDialogOpen={skipDialogOpen} setSkipDialogOpen={setSkipDialogOpen} skipComment={skipComment} setSkipComment={setSkipComment} handleConfirmSkipStep={handleConfirmSkipStep} skipStepName={controller.getCurrentStepFromApi()?.name} spLotIds={spLotIds} spLotInfo={spLotInfo} handleConfirmMarkAsDone={handleConfirmMarkAsDone} isActionInProgress={isActionInProgress} classes={classes} />
        </Box>
    );
};

export default ProcessingWorkflow;
